export function splitFilterCsv(value?: string): string[] {
  if (!value) return [];
  return value
    .split(",")
    .map((part) => part.trim())
    .filter((part) => part.length > 0);
}

export function joinFilterCsv(values?: readonly string[]): string | undefined {
  if (!values || values.length === 0) return undefined;
  return values.join(",");
}

export function optionalFilterCsv(value?: string): string[] | undefined {
  const values = splitFilterCsv(value);
  return values.length > 0 ? values : undefined;
}

export function toggleFilterValue(current: readonly string[], value: string): string[] {
  return current.includes(value) ? current.filter((item) => item !== value) : [...current, value];
}
